<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                v-if="editForeignTrade"
                :to="{
                    name: 'from-comex',
                }"
            >
                Imports
            </v-tab>
            <v-tab
                :to="{
                    name: 'comex-completed',
                }"
            >
                Completed
            </v-tab>
            <v-tab
                :to="{
                    name: 'comex-exportations',
                }"
            >
                Exports
            </v-tab>
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto px-4 pt-4"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import API from '@/services/api'

export default {
    name: 'ComexRoom',
    data: () => ({
        loading: true,
        height: 0,
        editForeignTrade: false,
    }),
    async mounted() {
        try {
            this.loading = true
            this.onResize()
            const {
                data: { user },
            } = await API.getMyInfo()
            this.editForeignTrade = user.permissions.includes(
                'editForeignTrade'
            )
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
    },
}
</script>

<style></style>
